"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoints = void 0;
const react_1 = require("react");
/**
 * A React-hook to keep track of viewport breakpoint changes
 */
const useBreakpoints = () => {
    return (0, react_1.useSyncExternalStore)(breakpointsObserver.subscribe, breakpointsObserver.getSnapshot);
};
exports.useBreakpoints = useBreakpoints;
const breakpointNames = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'];
const breakpointWidths = {
    xxs: 360,
    xs: 600,
    sm: 720,
    md: 1024,
    lg: 1440,
    xl: 1920,
};
const checkBreakpoints = (screenWidth) => {
    return {
        xxs: screenWidth >= breakpointWidths.xxs,
        xs: screenWidth >= breakpointWidths.xs,
        sm: screenWidth >= breakpointWidths.sm,
        md: screenWidth >= breakpointWidths.md,
        lg: screenWidth >= breakpointWidths.lg,
        xl: screenWidth >= breakpointWidths.xl,
    };
};
const createBreakpointsObserver = () => {
    let observer;
    let breakpoints = checkBreakpoints(window.innerWidth);
    let listeners = new Set();
    const initObserver = () => {
        observer = new ResizeObserver(() => {
            updateBreakpoints();
        });
        observer.observe(document.documentElement);
    };
    const subscribe = (listener) => {
        if (!observer)
            initObserver();
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
            if (listeners.size === 0) {
                observer === null || observer === void 0 ? void 0 : observer.disconnect();
                observer = undefined;
            }
        };
    };
    const getSnapshot = () => {
        return breakpoints;
    };
    const updateBreakpoints = () => {
        const newBreakpoints = checkBreakpoints(window.innerWidth);
        const hasChanged = breakpointNames.some(name => breakpoints[name] !== newBreakpoints[name]);
        if (hasChanged) {
            breakpoints = newBreakpoints;
            listeners.forEach(listener => listener());
        }
    };
    return {
        subscribe,
        getSnapshot,
    };
};
const breakpointsObserver = createBreakpointsObserver();
